// Auto-generated normalizer for table: Cat_Premios
export function catPremiosNormalize(row) {
  return {
    idPremio: row.idPremio ?? row.IdPremio ?? row['IdPremio'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    costo: row.costo ?? row.Costo ?? row['Costo'] ?? 0,
    rutaURL: row.rutaURL ?? row.RutaURL ?? row['RutaURL'] ?? '',
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
    fechaIniVigencia: row.fechaIniVigencia ?? row.FechaIniVigencia ?? row['FechaIniVigencia'] ?? row['FechaInicioVigencia'] ?? null,
    fechaFinVigencia: row.fechaFinVigencia ?? row.FechaFinVigencia ?? row['FechaFinVigencia'] ?? null,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
